import {OrderStatus} from '@wix/events-types'
import {
  getEventTitle,
  getPreliminaryInvoice,
  getTaxConfig,
  isAssignedTickets,
  isDateTbd,
} from '@wix/wix-events-commons-statics'
import {withTranslation} from '@wix/yoshi-flow-editor'
import {isTemplate} from '../../../../../../commons/selectors/instance'
import {ticketsHaveSeats} from '../../../../../../commons/selectors/tickets'
import {getEvent} from '../../../selectors/event'
import {showGroupCard} from '../../../selectors/groups'
import {isEventPreview} from '../../../selectors/navigation'
import {isPreparingOrder} from '../../../selectors/placed-order'
import {getPreliminaryInvoiceItems} from '../../../selectors/selected-tickets'
import {getTickets} from '../../../selectors/tickets'
import {State} from '../../../types/state'
import {DetailsPageAppProps} from '../../app/interfaces'
import {connect} from '../../runtime-context/context'
import {OrderSuccessRuntimeProps} from './interfaces'
import {OrderSuccess as Presentation} from './order-success'

const getOrderForDemoFlow = (state: State): wix.events.ticketing.Order => {
  const {checkout} = state

  const tickets = Object.keys(state.selectedTickets).map(key => ({
    ticketDefinitionId: key,
    ...getTickets(state).find(ticket => ticket.id === key),
  }))

  return {
    firstName: checkout.buyerDetails.firstName,
    email: checkout.buyerDetails.email,
    invoice: getPreliminaryInvoice(
      getTickets(state),
      getPreliminaryInvoiceItems(state),
      getTaxConfig(getEvent(state)) as wix.events.TaxConfig,
    ),
    status: OrderStatus.FREE,
    tickets,
    ticketsQuantity: tickets.length,
  }
}

const mapRuntime = ({state, actions: {ticketedThankYouPageLoaded}}: DetailsPageAppProps): OrderSuccessRuntimeProps => {
  const event = getEvent(state)
  const template = isTemplate(state)
  const eventPreview = isEventPreview(state)

  const order = template || eventPreview ? getOrderForDemoFlow(state) : state.placedOrder.order
  const {pollEnded} = state.placedOrder

  return {
    order,
    formattedOrderCreatedDate: state.dates.common.formattedOrderCreatedDate,
    eventTitle: getEventTitle(event),
    dateTbd: isDateTbd(event),
    isAssignedTickets: isAssignedTickets(event),
    taxConfig: getTaxConfig(event) as wix.events.TaxConfig,
    showGroup: showGroupCard(state),
    template,
    eventPreview,
    preparingOrder: isPreparingOrder(order),
    ticketedThankYouPageLoaded,
    orderHasSeats: ticketsHaveSeats(order?.tickets),
    pollEnded,
  }
}

export const OrderSuccess = connect<{}, OrderSuccessRuntimeProps>(mapRuntime)(withTranslation()(Presentation))
